import ServingTable from "./ServingTable";
import { Wrapper } from "../Style";

function Serving() {
  return (
    <Wrapper>
      <ServingTable />
    </Wrapper>
  );
}

export default Serving;
